export enum AuthType {
  STYTCH = "stytch",
}

export const AUTH_STORAGE_KEY = "authType";
export const SESSION_DURATION_TIME = 60 * 24 * 3; // 3 days
export const PENDING_AUTHORIZE_KEY = "focal_pending_authorize_url";
